import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../../store/index';

const setChipShown = (dispatch, module, classLabel, value) => {
  if (module === 'opac') {
    dispatch(actions.changeOpacitiesToShow(classLabel, value));
  } else if (module === 'calc') {
    dispatch(actions.changeMicrocalcToShow(classLabel, value));
  } else if (module === 'missed') {
    dispatch(actions.setShowMissedFindings(value));
  }
};

export const useDiagnosticsHandlers = (t) => {
  const dispatch = useDispatch();
  const [hoveredClass, setHoveredClass] = useState(null);
  const [lockedClasses, setLockedClasses] = useState(new Set());

  const handleEditButtonClick = useCallback(() => {
    dispatch(actions.setTabsIndex(2));
    dispatch(actions.setDiagnosticsInRevisionMode(true));
  }, [dispatch]);

  const handleTitleClick = useCallback(() => {
    dispatch(actions.setTabsIndex(2));
    dispatch(actions.setDiagnosticsInRevisionMode(true));
  }, [dispatch]);

  const onMicrocalcConfirmClick = useCallback(
    (microcalcShown, shown_microcalc, applied_microcalc, confirmed_microcalc) => {
      const state = shown_microcalc === applied_microcalc && confirmed_microcalc;
      dispatch(actions.confirmEvaluation(microcalcShown, 'microcalc', !state, t));
    },
    [dispatch, t]
  );

  const onOpacitiesConfirmClick = useCallback(
    (opacitiesShown, shown_opacities, applied_opacities, confirmed_opacities) => {
      const state = shown_opacities === applied_opacities && confirmed_opacities;
      dispatch(actions.confirmEvaluation(opacitiesShown, 'opacities', !state, t));
    },
    [dispatch, t]
  );

  const handleChipMouseEnter = useCallback(
    (module, exist, isShown, classLabel, lockedClasses) => {
      if (!exist) return;
      setHoveredClass([module, classLabel]);

      const key = `${module}_${classLabel}`;
      if (!lockedClasses.has(key) && !isShown) {
        setChipShown(dispatch, module, classLabel, true);
      }
    },
    [dispatch]
  );

  const handleChipMouseLeave = useCallback(
    (module, classLabel, lockedClasses) => {
      setHoveredClass(null);

      const key = `${module}_${classLabel}`;
      if (!lockedClasses.has(key)) {
        setChipShown(dispatch, module, classLabel, false);
      }
    },
    [dispatch]
  );

  const handleChipClick = useCallback(
    (module, classLabel, isShown, overlaysExist, lockedClasses, setLockedClasses) => {
      if (!overlaysExist) return;

      const key = `${module}_${classLabel}`;
      const updated = new Set(lockedClasses);

      if (lockedClasses.has(key)) {
        updated.delete(key);
        if (isShown) {
          setChipShown(dispatch, module, classLabel, false);
        }
      } else {
        updated.add(key);
        if (!isShown) {
          setChipShown(dispatch, module, classLabel, true);
        }
      }

      setLockedClasses(updated);
    },
    [dispatch]
  );

  return {
    hoveredClass,
    lockedClasses,
    setLockedClasses,
    handleEditButtonClick,
    handleTitleClick,
    onMicrocalcConfirmClick,
    onOpacitiesConfirmClick,
    handleChipMouseEnter,
    handleChipMouseLeave,
    handleChipClick,
  };
};
